export default "__VITE_ASSET__DzvZru74__"